export enum Env {
    Release = 'Release',
    Test = 'Test',
}

interface IConfig {
    hiddenAIGenerateImage?: boolean;
}

export const imageLayerAiMenuConfig: IConfig = {
    hiddenAIGenerateImage: false,
};

export const setImageLayerAiMenuConfig = (config: Partial<IConfig>) => {
    Object.assign(imageLayerAiMenuConfig, config);
};
